import { firestore } from "../firebase/firebaseClient";

export const getCurrentInfo = (id, setInfo) => {
  return firestore.doc(`users/${id}`).onSnapshot((snapshot) => {
    const info = snapshot.data();
    setInfo(info);
  });
};
